module.exports = __webpack_public_path__ + "img/logo.4ac32ae0.png";